import React from "react";
import { DonutChartLoader } from "Components/DonutChart/Loader";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

export const Loader: React.FC = () => {
  return (
    <Container>
      <Skeleton height={25} width={250} />
      <DonutChartLoader />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: center;
  margin-bottom: 8px;
`;
